module.exports = __webpack_public_path__ + "assets/media/marker_active.a04d6b84.svg";